import { generatePath, useNavigate } from "react-router-dom";
import { SHOW_EXHIBITOR_ORDER_DETAILS_PATH } from "view/routes";

const useRedirectToOrderPage = (showId: string, exhibitorPairId: string) => {
  const history = useNavigate();
  return (orderId: string, orderGroupId?: string | null) => {
    let relatedOrderIdParam = "";

    if (orderGroupId) {
      relatedOrderIdParam = `?orderGroupId=${orderGroupId}`;
    }

    history(
      generatePath(
        `${SHOW_EXHIBITOR_ORDER_DETAILS_PATH}/${relatedOrderIdParam}`,
        {
          showId,
          exhibitorPairId,
          orderId,
        }
      )
    );
  };
};

export default useRedirectToOrderPage;
